import { colorSceneLight, colorSceneDark, } from '@ks/kwcolor/color/output/common/index';
export const light = colorSceneLight;
export const dark = colorSceneDark;
